import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ThemeContext from '../context/ThemeContext';
import '../styles/Terms.css';

const Privacy = () => {
  const { accentColor } = useContext(ThemeContext);

  return (
     <div>
      <div className="terms-wrapper">
     <div className="terms-card">
     <Link className="termslink" to="/"> | Home |</Link>
     <h1 className="terms"> Privacy Policy</h1>
     <p className="termsp">
     EditFarmer – Privacy Policy

Effective Date: 2/21/2026
Company: Const and Props, LLC
Contact: support@editfarmer.com
<hr></hr>
1. Information We Collect -

We may collect:

Name,

Email address,

Billing information,

IP address,

Basic website analytics data

If you purchase the Software, payment details are processed securely by third-party payment providers. We do not store full credit card information.
<hr></hr>
2. How We Use Information

We use collected information to:

Process purchases,

Deliver license access,

Provide customer support,

Improve website performance,

Communicate important updates

We do not sell your personal information.
<hr></hr>
3. Desktop Software

The Carrot Download by EditFarmer is a desktop application. Media files processed by the Software remain on your local machine unless you connect third-party services.

We do not automatically collect your local media files.
<hr></hr>
4. Third-Party Services

We may use:

Payment processors,

Hosting providers,

Analytics tools,

These services operate under their own privacy policies.
<hr></hr>
5. Data Security

We implement reasonable security measures to protect personal information. However, no system is completely secure.
<hr></hr>
6. Your Rights

You may request:

Access to your personal information

Correction of inaccurate information

Deletion of your account information (subject to legal obligations)

Contact: support@editfarmer.com
<hr></hr>
7. Updates

We may update this Privacy Policy periodically. Continued use of the website constitutes acceptance of changes.
  </p>
  </div>
     </div>
    </div>
    
  );
};

export default Privacy;
